module.exports = __webpack_public_path__ + "static/media/cantoo.d407f733.png";